module.exports = __webpack_public_path__ + "cc9afd0ff167793b67fc7ea9778e7925.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/pap_testimonial-2-author.jpg
// module id = 3072
// module chunks = 2